import { props as shouldForwardProp } from '@styled-system/should-forward-prop';
export const ignoredProps = [...shouldForwardProp, 'font', 'theme'];
//# sourceMappingURL=ignoredProps.js.map